/* tslint:disable */

/**
 */
export class Partner {
    phone?: string;
    id?: number;
    app_key?: string;
    company_name?: string;
    company_fullname?: string;
    address?: string;
    partner_code?: string;
    url?: string;
    email?: string;
    group_company?: string;
    created_at?: string;
    updated_at?: string;
}
